"use client";

import { useAuth } from "@/hooks/use-auth";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { LoadingScreen } from "@/components/ui/loading-screen";


export default function Home() {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    // Simple landing page behavior
    // If not authenticated, redirect to sign-in
    // If authenticated, redirect to dashboard
    if (!isLoading) {
      if (isAuthenticated) {
        router.push("/dashboard");
      } else {
        router.push("/sign-in");
      }
    }
  }, [isLoading, isAuthenticated, router]);

  // Show loading state while checking authentication
  return <LoadingScreen message="Loading..." fullScreen />;
}
